/**
 * Alle festen Texte der Oberfläche an einer Stelle.
 *
 * Die App ist bewusst einsprachig deutsch. Diese Sammlung hält die
 * Formulierungen einheitlich und macht spätere Änderungen einfach.
 */
export const texts = {
  app: {
    name: 'Kochbuch',
    tagline: 'Rezepte, die gelingen.',
  },
  nav: {
    recipes: 'Rezepte',
    favorites: 'Merkliste',
    search: 'Suche',
    shopping: 'Einkauf',
    products: 'Produkte',
    cookbooks: 'Kochbücher',
    settings: 'Einstellungen',
    newRecipe: 'Neues Rezept',
  },
  favorites: {
    title: 'Merkliste',
    subtitle: 'Rezepte, die du mit dem Herz vorgemerkt hast.',
    empty: 'Noch nichts vorgemerkt. Tippe auf das Herz eines Rezepts.',
    add: 'Zur Merkliste hinzufügen',
    remove: 'Von der Merkliste entfernen',
    only: 'nur Merkliste',
  },
  auth: {
    setupTitle: 'Kochbuch einrichten',
    setupIntro:
      'Beim ersten Start wird das Verwaltungskonto angelegt. Weitere Personen im Haushalt kannst du später in den Einstellungen hinzufügen.',
    loginTitle: 'Anmelden',
    loginIntro: 'Bitte mit dem eigenen Konto anmelden.',
    username: 'Anmeldename',
    displayName: 'Anzeigename',
    password: 'Passwort',
    passwordRepeat: 'Passwort wiederholen',
    currentPassword: 'Bisheriges Passwort',
    newPassword: 'Neues Passwort',
    login: 'Anmelden',
    logout: 'Abmelden',
    setup: 'Konto anlegen',
    changePassword: 'Passwort ändern',
    mustChange: 'Bitte zuerst ein eigenes Passwort setzen.',
    passwordsDiffer: 'Die beiden Passwörter stimmen nicht überein.',
  },
  recipes: {
    title: 'Rezepte',
    empty: 'Noch keine Rezepte. Lege das erste an!',
    emptyFiltered: 'Kein Rezept passt zu den gewählten Filtern.',
    newRecipe: 'Neues Rezept',
    searchPlaceholder: 'Name, Zutat, Tag oder Kategorie',
    results: 'Rezepte',
    gridView: 'Kacheln',
    listView: 'Liste',
    clearFilters: 'Alle zurücksetzen',
    quick: 'Schnellfilter',
    quickFast: 'Schnell (bis 30 Min)',
    quickEasy: 'Leicht',
    quickTop: 'Top bewertet',
    quickNew: 'Neu',
    quickLastCooked: 'Zuletzt gekocht',
    quickLongAgo: 'Lange nicht gekocht',
    categories: 'Kategorien',
    popularTags: 'Beliebte Schlagwörter',
    allTags: 'Alle Schlagwörter',
    newest: 'Zuletzt hinzugefügt',
    bestRated: 'Am besten bewertet',
    sort: 'Sortierung',
    sortRelevance: 'Passung',
    sortRating: 'Bewertung',
    sortTotalTime: 'Gesamtzeit',
    sortActiveTime: 'Aktive Zeit',
    sortNewest: 'Neueste',
    sortLastCooked: 'Zuletzt gekocht',
    sortTitle: 'Titel A–Z',
  },
  filter: {
    title: 'Filter',
    difficulty: 'Schwierigkeit',
    maxTotalTime: 'Höchstens Gesamtzeit',
    maxActiveTime: 'Höchstens aktive Zeit',
    rating: 'Mindestens Bewertung',
    ratingMine: 'Meine Bewertung',
    ratingAverage: 'Durchschnitt',
    tags: 'Schlagwörter',
    tagsMode: 'Mehrere Schlagwörter',
    tagsAny: 'mindestens eines',
    tagsAll: 'alle',
    ingredients: 'Zutaten',
    with: 'mit',
    without: 'ohne',
    apply: 'Ergebnisse anzeigen',
    close: 'Schließen',
  },
  detail: {
    ingredients: 'Zutaten',
    steps: 'Arbeitsschritte',
    equipment: 'Das brauchst du',
    times: 'Zeiten',
    ratings: 'Bewertungen',
    myRating: 'Meine Bewertung',
    ratingSaved: 'Bewertung gespeichert.',
    cookMode: 'Kochmodus starten',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    deleteConfirm: 'Rezept wirklich löschen? Das lässt sich nicht rückgängig machen.',
    createdBy: 'Angelegt von',
    lastCooked: 'Zuletzt gekocht',
    neverCooked: 'Noch nicht gekocht',
    preparation: 'Vorbereitung',
    active: 'Zubereitung',
    cooking: 'Kochen',
    baking: 'Backen',
    resting: 'Ruhen',
    cooling: 'Kühlen',
    total: 'Gesamt',
    commentPlaceholder: 'Notiz für das nächste Mal (optional)',
    rateNow: 'Bewerten',
    removeRating: 'Zurücknehmen',
    onTheTable: 'steht bereit',
    cooksIn: 'Kochzeit',
    section: 'Abschnitt',
    temperature: 'Temperatur',
    duration: 'Dauer',
    minutesShort: 'Min.',
    passiveHint: 'Passiv: Du musst nicht daneben stehen.',
    noRatings: 'Noch keine Bewertung.',
  },
  cook: {
    title: 'Kochmodus',
    miseEnPlace: 'Alles bereit?',
    miseIntro: 'Lege alles bereit und hake ab, was auf dem Tisch steht.',
    startCooking: 'Los geht es',
    step: 'Schritt',
    of: 'von',
    next: 'Weiter',
    previous: 'Zurück',
    finish: 'Fertig',
    timerStart: 'Timer starten',
    timerPause: 'Pause',
    timerReset: 'Zurück auf null',
    timerDone: 'Zeit ist um!',
    whyItWorks: 'Warum das so ist',
    doneWhen: 'Fertig, wenn …',
    exit: 'Kochmodus beenden',
    exitConfirm: 'Kochmodus wirklich beenden?',
    keepAwake: 'Bildschirm bleibt an',
    readAloud: 'Vorlesen',
    stopReading: 'Vorlesen beenden',
    autoRead: 'Jeden Schritt automatisch vorlesen',
    preheatNow: 'Ofen jetzt vorheizen',
    preheatDetail: 'in etwa {min} Min. wird er in Schritt {step} gebraucht.',
    preheatSoon: 'gleich im nächsten Schritt gebraucht.',
    warmUp: 'Rechtzeitig herausnehmen, damit sie Zimmertemperatur haben',
    finishedTitle: 'Fertig gekocht!',
    finishedIntro: 'Wie war es? Deine Bewertung hilft beim nächsten Mal.',
    saveAndFinish: 'Speichern und schließen',
    skipRating: 'Ohne Bewertung schließen',
  },
  editor: {
    newTitle: 'Neues Rezept',
    editTitle: 'Rezept bearbeiten',
    basics: 'Grundlagen',
    titleLabel: 'Titel',
    description: 'Kurzbeschreibung',
    difficulty: 'Schwierigkeit',
    baseYield: 'Ergibt',
    times: 'Zeiten in Minuten',
    equipment: 'Geräte und Werkzeuge',
    equipmentHint: 'Mit Komma trennen, zum Beispiel: Küchenmaschine, Springform 26 cm',
    categories: 'Kategorien',
    tags: 'Schlagwörter',
    tagsHint: 'Mit Komma trennen. Neue Schlagwörter entstehen dabei automatisch.',
    ingredients: 'Zutaten',
    quickAdd: 'Schnelleingabe',
    quickAddHint: 'Eine Zutat je Zeile, zum Beispiel: 200 g Mehl. Menge, Einheit und Name werden erkannt.',
    quickAddApply: 'Übernehmen',
    addIngredient: 'Zutat hinzufügen',
    addStep: 'Schritt hinzufügen',
    steps: 'Arbeitsschritte',
    amount: 'Menge',
    unit: 'Einheit',
    name: 'Zutat',
    note: 'Zusatz',
    scaling: 'Umrechnung',
    scalingLinear: 'wächst mit',
    scalingRounded: 'gerundet',
    scalingSublinear: 'unterproportional',
    scalingFixed: 'bleibt gleich',
    stepTitle: 'Kurztitel',
    instruction: 'Anleitung',
    duration: 'Dauer in Minuten',
    temperature: 'Temperatur in Grad',
    passive: 'Passiv (nicht daneben stehen)',
    parallel: 'Gleichzeitig mit dem vorigen Schritt möglich',
    timer: 'Timer anbieten',
    whyItWorks: 'Warum funktioniert das?',
    doneWhen: 'Woran erkenne ich, dass es fertig ist?',
    moveUp: 'Nach oben',
    moveDown: 'Nach unten',
    remove: 'Entfernen',
    save: 'Speichern',
    cancel: 'Abbrechen',
    saved: 'Gespeichert.',
    hintForBeginners: 'Hilfen für Anfänger',
    media: 'Bilder und Videos',
    mediaHint: 'Bilder werden automatisch verkleinert. Das erste Bild ist das Titelbild. Videos bis 500 MB.',
    mediaAdd: 'Bild oder Video hinzufügen',
    mediaCamera: 'Kamera',
    mediaCover: 'Titelbild',
    mediaMakeCover: 'Als Titelbild',
    mediaSaveFirst: 'Bitte das Rezept zuerst speichern, dann lassen sich Bilder und Videos hinzufügen.',
    mediaUploading: 'Wird hochgeladen …',
    stepMedia: 'Eigene Bilder und Videos',
    stepMediaHint:
      'Fotos oder kurze Videos zeigen, wie es aussehen soll. Sie erscheinen beim Schritt neben der Animation.',
    stepMediaAdd: 'Bild oder Video hinzufügen',
    stepMediaRemove: 'Entfernen',
    stepMediaMove: 'Bild oder Video',
    stepMediaOffline: 'Zum Hochladen ist eine Verbindung zum Server nötig.',
  },
  webImport: {
    title: 'Aus einer Webseite übernehmen',
    hint: 'Nur für den privaten Gebrauch. Gelesen werden die strukturierten Rezeptdaten der Seite; die Quelle steht danach in der Beschreibung. Bitte alles vor dem Speichern prüfen.',
    address: 'Adresse der Rezeptseite',
    run: 'Einlesen',
    done: 'Übernommen: {count} Zutaten. Bitte prüfen und dann speichern.',
    imageFailed: 'Das Rezept ist gespeichert, das Bild konnte aber nicht übernommen werden.',
  },
  sync: {
    waiting: '{count} Änderungen warten auf Verbindung und werden dann gespeichert.',
    conflicts: '{count} Änderungen brauchen deine Entscheidung.',
    statusWaiting: 'Wartet auf Verbindung.',
    statusConflict: 'Wurde inzwischen auf einem anderen Gerät geändert.',
    statusFailed: 'Konnte nicht gespeichert werden',
    keepMine: 'Meine Fassung speichern',
    keepTheirs: 'Andere Fassung behalten',
    retry: 'Erneut versuchen',
    discard: 'Verwerfen',
    tryNow: 'Jetzt erneut versuchen',
    saveAppearance: 'Darstellung im Konto speichern',
    savedOffline:
      'Ohne Verbindung gespeichert. Die Änderung wird übertragen, sobald das Gerät wieder online ist.',
    conflictTitle: 'Das Rezept wurde inzwischen geändert',
    conflictText: 'Auf einem anderen Gerät wurde dieses Rezept gespeichert, während du es bearbeitet hast.',
    conflictMine: 'Meine Änderungen speichern',
    conflictTheirs: 'Neuere Fassung laden (meine Änderungen verwerfen)',
    saveOffline: 'Videos dieses Rezepts für offline speichern',
    savingOffline: 'Wird gespeichert …',
    savedForOffline: 'Videos offline verfügbar',
  },
  shopping: {
    title: 'Einkaufsliste',
    subtitle: 'Gemeinsam für den Haushalt. Funktioniert auch ohne Netz im Laden.',
    tabList: 'Liste',
    tabPantry: 'Vorrat',
    tabStores: 'Läden',
    list: 'Liste',
    newList: 'Neue Liste',
    newListPrompt: 'Name der neuen Liste',
    renameList: 'Umbenennen',
    deleteList: 'Liste löschen',
    deleteListConfirm: 'Diese Liste mit allen Einträgen löschen?',
    renameListPrompt: 'Neuer Name der Liste',
    listActions: 'Liste verwalten',
    quickAdd: 'Hinzufügen',
    quickAddPlaceholder: 'z. B. 2 l Milch oder Brot',
    sortBy: 'Sortieren nach',
    sortCategories: 'Warengruppen',
    empty: 'Die Liste ist leer. Füge oben etwas hinzu oder übernimm die Zutaten eines Rezepts.',
    inCart: 'Im Wagen',
    clearChecked: 'Erledigte entfernen',
    clearToPantry: 'In den Vorrat und entfernen',
    from: 'aus',
    estimate: 'Geschätzt',
    offline: 'Offline – Änderungen werden gespeichert und später abgeglichen.',
    pending: 'Änderungen warten auf den Abgleich',
    synced: 'Abgeglichen',
    edit: 'Bearbeiten',
    remove: 'Entfernen',
    save: 'Übernehmen',
    name: 'Name',
    amount: 'Menge',
    unit: 'Einheit',
    note: 'Notiz',
    category: 'Warengruppe',
    addFromRecipe: 'Auf die Einkaufsliste',
    addDialogTitle: 'Zutaten auf die Einkaufsliste',
    addDialogHint: 'Wähle aus, was du kaufen musst. Vorräte sind schon abgezogen.',
    targetList: 'Auf die Liste',
    fromPantry: 'aus dem Vorrat',
    pantryDeducted: 'Vorrat abgezogen, Bedarf',
    atHome: 'meist im Haus',
    addSelected: 'Hinzufügen',
    added: 'Auf der Liste',
    addedSummary: 'neu, zusammengefasst',
    openList: 'Liste öffnen',
    pantryEmpty:
      'Noch keine Vorräte. Trage ein, was im Haus ist – es wird beim Übernehmen von Rezepten abgezogen.',
    pantryAddPlaceholder: 'z. B. 1 kg Mehl oder Salz',
    storesEmpty:
      'Noch keine Läden. Lege einen Laden an und ordne die Warengruppen so, wie du durch die Gänge gehst.',
    newStore: 'Neuer Laden',
    storeName: 'Name des Ladens',
    aisleOrder: 'Reihenfolge der Gänge',
    moveUp: 'Früher',
    moveDown: 'Später',
    deleteStore: 'Laden löschen',
    renameStore: 'Umbenennen',
    package: 'Packung',
  },
  products: {
    title: 'Produkte',
    subtitle: 'Produkte mit Herstellern, Packungsgrößen, Preisen, Bildern und Barcodes.',
    search: 'Produkt, Marke oder EAN suchen',
    newProduct: 'Neues Produkt',
    empty:
      'Noch keine Produkte. Produkte helfen, gleiche Zutaten zusammenzufassen und Packungen vorzuschlagen.',
    name: 'Name',
    category: 'Warengruppe',
    defaultUnit: 'Übliche Einheit',
    synonyms: 'Weitere Namen',
    synonymsHint: 'Mit Komma trennen, zum Beispiel: Weizenmehl, Mehl Type 405',
    note: 'Notiz',
    image: 'Bild',
    uploadImage: 'Bild wählen',
    removeImage: 'Bild entfernen',
    variants: 'Packungen',
    addVariant: 'Packung hinzufügen',
    brand: 'Hersteller',
    label: 'Bezeichnung',
    packageAmount: 'Inhalt',
    packageUnit: 'Einheit',
    ean: 'EAN',
    price: 'Preis in €',
    preferred: 'Bevorzugt',
    delete: 'Löschen',
    deleteConfirm: 'Produkt mit allen Packungen löschen?',
    back: 'Alle Produkte',
    saved: 'Gespeichert.',
    nutrition: 'Nährwerte je 100 g',
    nutritionHint:
      'Leer lassen, um die Richtwerte zu nutzen (grau vorgeschlagen). Eigene Werte gelten in allen Rezepten mit dieser Zutat.',
    pieceGrams: 'Gewicht eines Stücks in g',
  },
  scan: {
    title: 'Per Barcode hinzufügen',
    button: 'Scannen',
    cameraStarting: 'Kamera wird gestartet …',
    aim: 'Strichcode in den Rahmen halten',
    cameraInsecure:
      'Die Kamera ist nur über eine sichere Verbindung (https) verfügbar. Der Code lässt sich unten eintippen.',
    cameraDenied: 'Der Zugriff auf die Kamera wurde nicht erlaubt. Der Code lässt sich unten eintippen.',
    cameraUnavailable: 'Keine Kamera gefunden. Der Code lässt sich unten eintippen.',
    manual: 'Code eintippen',
    manualPlaceholder: 'EAN, zum Beispiel 4000417025005',
    searchCode: 'Suchen',
    invalidCode: 'Das ist kein gültiger Strichcode (8, 12, 13 oder 14 Ziffern mit Prüfziffer).',
    searching: 'Suche nach {code} …',
    offline: 'Ohne Verbindung lässt sich nicht nachschlagen.',
    known: '„{name}“ ist schon unter deinen Produkten.',
    addToList: 'Auf die Einkaufsliste',
    notFound:
      'Zu {code} gibt es weder ein eigenes Produkt noch einen Eintrag in Open Food Facts. Du kannst das Produkt selbst anlegen.',
    disabled: 'Zu {code} gibt es kein eigenes Produkt; Abfragen an freie Datenbanken sind abgeschaltet.',
    createOwn: 'Anlegen',
    productName: 'Name des Produkts',
    nameHint:
      'Ein allgemeiner Name („Spaghetti“) fasst Packungen verschiedener Marken zusammen und findet die Zutat im Rezept.',
    adoptAs: 'Übernehmen als',
    asNew: 'Neues Produkt',
    asVariant: 'Weitere Packung von …',
    chooseProduct: 'Produkt wählen',
    per100: 'je 100 g',
    sourceNote: 'Angaben aus',
    licenseData: 'Daten unter {data}',
    licenseBoth: 'Daten unter {data}, Bild unter {image}',
    licenseImage: 'Bild unter {image}',
    contains: 'Enthält',
    adopt: 'Übernehmen',
    adoptAndAdd: 'Übernehmen und auf die Liste',
    adopting: 'Wird übernommen …',
    adopted: '„{name}“ ist übernommen.',
    addedToList: '„{name}“ steht auf der Einkaufsliste.',
    next: 'Nächsten Code scannen',
    scanAgain: 'Neu scannen',
    openProduct: 'Zum Produkt',
    searchSources: 'In Open Food Facts suchen',
    searchPlaceholder: 'Produkt oder Marke, zum Beispiel Haferflocken',
    searchingShort: 'Sucht …',
    searchDisabled: 'Abfragen an freie Datenbanken sind abgeschaltet.',
    noResults: 'Keine Treffer.',
    backToResults: 'Zurück zu den Treffern',
    searchNote:
      'Gesucht wird in Produkten, die in Deutschland verkauft werden. An die Datenbank gehen nur Suchbegriff und Strichcode.',
    from: 'Aus',
    dataLicense: 'Daten',
    imageLicense: 'Bild',
  },
  cookbooks: {
    title: 'Kochbücher',
    subtitle: 'Eigene Kochbücher als PDF: Rezepte auswählen, in Kapitel ordnen, drucken oder verschenken.',
    newTitle: 'Titel des neuen Kochbuchs',
    create: 'Anlegen',
    empty: 'Noch keine Kochbücher. Lege eines an und wähle die Rezepte aus.',
    recipes: '{count} Rezepte',
    back: 'Alle Kochbücher',
    head: 'Titel und Vorwort',
    bookTitle: 'Titel',
    bookSubtitle: 'Untertitel',
    preface: 'Vorwort',
    prefaceHint: 'Absätze durch eine Leerzeile trennen.',
    cover: 'Titelbild',
    chooseCover: 'Bild wählen',
    removeCover: 'Entfernen',
    settings: 'Gestaltung',
    format: 'Format',
    photos: 'Titelbilder der Rezepte',
    animations: 'Bilder zu den Schritten',
    nutrition: 'Nährwerte',
    ratings: 'Bewertungen',
    index: 'Zutatenverzeichnis mit Seitenzahlen',
    chapters: 'Kapitel und Reihenfolge',
    chapterTitle: 'Name des Kapitels',
    newChapter: 'Neues Kapitel',
    addChapter: 'Kapitel hinzufügen',
    emptyChapter: 'Noch keine Rezepte in diesem Kapitel.',
    up: 'Nach oben',
    down: 'Nach unten',
    remove: 'Entfernen',
    removeChapter: 'Kapitel entfernen',
    add: 'Rezepte hinzufügen',
    addTo: 'Hinzufügen zu',
    fromCategories: 'Je Kategorie ein Kapitel',
    fromSource: 'Als neues Kapitel',
    category: 'Kategorie: {name}',
    tag: 'Schlagwort: {name}',
    favorites: 'Meine Merkliste',
    favoritesChapter: 'Lieblingsrezepte',
    search: 'Rezept suchen',
    added: 'schon drin',
    save: 'Speichern',
    saved: 'Gespeichert.',
    unsaved: 'Ungespeicherte Änderungen',
    build: 'PDF erzeugen',
    rebuild: 'Neu erzeugen',
    building: 'Wird erzeugt … {percent} %',
    buildHint:
      'Das dauert je nach Umfang einige Sekunden; die Seite darf dabei offen bleiben oder geschlossen werden.',
    download: 'Herunterladen',
    builtInfo: '{pages} Seiten · {size} · erzeugt am {date}',
    stale: 'Seit dem Erzeugen geändert – neu erzeugen, damit das PDF aktuell ist.',
    failed: 'Erzeugen fehlgeschlagen: {message}',
    delete: 'Kochbuch löschen',
    deleteConfirm: 'Kochbuch löschen? Die Rezepte bleiben erhalten.',
  },
  footer: {
    copyright: '© {year} protocol7.de',
    imprint: 'Impressum',
    privacy: 'Datenschutz',
    version: 'Version {version}',
  },
  pdf: {
    button: 'PDF',
    format: 'Papierformat',
    photos: 'Titelbild',
    animations: 'Bilder zu den Schritten',
    nutrition: 'Nährwerte',
    download: 'PDF herunterladen',
    hint: 'Mit der gerade gewählten Menge und den gewählten Einheiten.',
  },
  print: {
    print: 'Drucken',
    amount: 'Für {amount} {unit}',
  },
  baseStock: {
    title: 'Grundbestand importieren',
    button: 'Grundbestand',
    hint: 'Rund 300 allgemeine Zutaten und Haushaltswaren mit Warengruppe und weiteren Namen. Vorhandenes wird nicht doppelt angelegt.',
    allOf: 'Alle aus {group}',
    exists: 'vorhanden',
    import: '{count} Produkte anlegen',
    importing: 'Wird angelegt …',
    result: '{created} Produkte angelegt, {skipped} waren schon vorhanden.',
    next: 'Bilder und Nährwerte lassen sich je Produkt unter „Daten ergänzen“ aus den freien Datenbanken holen.',
  },
  supplement: {
    title: 'Daten ergänzen',
    needEan:
      'Für Markenware: Trage bei einer Packung die EAN ein oder scanne sie. Dann lassen sich Angaben aus Open Food Facts ergänzen.',
    none: 'Zu diesem Produkt gibt es keine passenden Einträge in den freien Datenbanken.',
    hint: 'Vorausgewählt sind nur Felder, die bisher leer sind. Eigene Angaben bleiben, solange du sie nicht anhakst.',
    forPackage: 'zur Packung',
    general: 'allgemein, aus {source}',
    field: 'Feld',
    current: 'Jetzt',
    found: 'Gefunden',
    nutrition: 'Nährwerte je 100 g',
    productImage: 'Bild des Produkts',
    variantImage: 'Bild der Packung',
    details: 'Allergene und Siegel',
    apply: '{count} Felder übernehmen',
    applyOne: '1 Feld übernehmen',
    applied: 'Übernommen.',
  },
  nutrition: {
    title: 'Nährwerte',
    perPortion: 'je Portion',
    perPerson: 'je Person',
    perPiece: 'je Stück',
    perPan: 'für die ganze Form',
    estimate: 'Richtwerte',
    coverage: 'Berechnet aus {counted} von {measurable} Zutaten mit Mengenangabe.',
    missing: 'Ohne Werte: {names}.',
    disclaimer:
      'Grobe Orientierung aus Durchschnittswerten, keine Ernährungsberatung. Eigene Werte lassen sich bei den Produkten eintragen.',
    none: 'Für dieses Rezept lassen sich noch keine Nährwerte schätzen.',
    fields: {
      kcal: 'Energie',
      protein: 'Eiweiß',
      fat: 'Fett',
      carbs: 'Kohlenhydrate',
      sugar: 'davon Zucker',
      fiber: 'Ballaststoffe',
      salt: 'Salz',
    },
  },
  scale: {
    title: 'Menge',
    less: 'Weniger',
    more: 'Mehr',
    reset: 'Wie im Rezept',
    original: 'Im Rezept',
    pan: 'Deine Form',
    round: 'rund',
    rect: 'eckig',
    diameter: 'Durchmesser in cm',
    width: 'Breite in cm',
    length: 'Länge in cm',
    factor: 'Mengen',
    units: 'Einheiten',
    convertedFrom: 'statt',
    timeBar: 'Zeitverteilung',
    flow: 'Ablauf der Schritte',
    plan: 'Ablaufplan',
    planSaves: 'statt {sequential} nacheinander',
    planEstimated: 'Dauer geschätzt',
    meanwhile: 'Nebenbei möglich',
    activeLegend: 'aktiv',
    passiveLegend: 'warten',
    placeholders: 'Mengen einsetzen',
    placeholdersHint:
      'Ein Platzhalter wie {mehl} setzt die Menge ein und passt sie beim Umrechnen an. {mehl/2} ist die Hälfte, {mehl:menge} nur die Menge ohne Namen.',
    preview: 'So erscheint der Text',
    unknownPlaceholder: 'Unbekannter Platzhalter',
  },
  animation: {
    section: 'Animation zum Schritt',
    sectionHint: 'Eine Animation zeigt Anfängern, wie der Schritt geht.',
    none: 'Noch keine Animation gewählt.',
    suggestions: 'Passt zum Text',
    noSuggestions: 'Zum Text passt keine Vorlage. Wähle unten selbst eine aus.',
    gallery: 'Alle Vorlagen',
    choose: 'Auswählen',
    change: 'Andere wählen',
    remove: 'Animation entfernen',
    settings: 'Einstellungen der Animation',
    play: 'Animation abspielen',
    pause: 'Animation anhalten',
  },
  settings: {
    title: 'Einstellungen',
    household: 'Haushalt',
    account: 'Eigenes Konto',
    categories: 'Kategorien',
    tags: 'Schlagwörter',
    people: 'Personen',
    addPerson: 'Person hinzufügen',
    startPassword: 'Startpasswort',
    resetPassword: 'Passwort zurücksetzen',
    role: 'Rolle',
    roleAdmin: 'Verwaltung',
    roleMember: 'Mitglied',
    displayName: 'Anzeigename',
    newCategory: 'Neue Kategorie',
    newTag: 'Neues Schlagwort',
    usedIn: 'Rezepte',
    onlyAdmin: 'Nur die Verwaltung kann diesen Bereich ändern.',
    appearance: 'Darstellung',
    appearanceAccount: 'Wird in deinem Konto gespeichert und gilt auf allen deinen Geräten.',
    appearanceDevice: 'Gilt nur auf diesem Gerät; dein Konto bleibt unverändert.',
    deviceOnly: 'Auf diesem Gerät abweichend einstellen',
    theme: 'Farbschema',
    themes: { system: 'Wie das System', light: 'Hell', dark: 'Dunkel' },
    background: 'Hintergrund',
    backgrounds: {
      plain: 'Schlicht',
      warm: 'Warmer Schein',
      linen: 'Leinen',
      gingham: 'Karo',
      tiles: 'Fliesen',
      dots: 'Tupfen',
      herbs: 'Kräuter',
    },
    storage: 'Speicherort',
    storageHint: 'Datenbank, Bilder und Videos liegen im Volume des Containers unter /data.',
  },
  common: {
    comingSoon: 'Dieser Bereich entsteht in einer der nächsten Phasen.',
    phase: 'Geplant in',
    loading: 'Einen Moment bitte …',
    save: 'Speichern',
    cancel: 'Abbrechen',
    close: 'Schließen',
    back: 'Zurück',
    error: 'Es ist ein Fehler aufgetreten.',
    retry: 'Erneut versuchen',
    yes: 'Ja',
    no: 'Nein',
    minutes: 'Min.',
    optional: 'optional',
    dragHandle: 'Zum Verschieben ziehen oder mit den Pfeiltasten bewegen',
  },
  phases: {
    shopping: 'Phase 4 – Einkaufsliste',
    products: 'Phase 5 – Produkte und freie Datenbanken',
  },
} as const;
